module.exports = __webpack_public_path__ + "static/media/locations-small.3a0cf786.webp";